 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		7: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "sports2-static/chunk." + ({"0":"source~/esports-betting-rules-TR~bet-builder-rules-DE~bet-builder-rules-EN~bet-builder-rules-ES~bet-~078fb09e","1":"source~/esports-betting-rules-TR~bet-builder-rules-DE~bet-builder-rules-EN~bet-builder-rules-ES~bet-~e20a97ce","2":"source~/esports-betting-rules-TR~esports-betting-rules-DA~esports-betting-rules-DE~esports-betting-r~11b5dbfd","5":"source~virtual-esports-betting-rules-EN~virtual-esports-betting-rules-IT~virtual-esports-betting-rul~c400071f","8":"source~i18n-widgets-en-json","9":"source~i18n-widgets-fr-json","12":"source~/esports-betting-rules-TR","13":"source~bet-builder-rules-DE","14":"source~bet-builder-rules-EN","15":"source~bet-builder-rules-ES","16":"source~bet-builder-rules-ES-MX","17":"source~bet-builder-rules-ET","18":"source~bet-builder-rules-FI","19":"source~bet-builder-rules-FR","20":"source~bet-builder-rules-IT","21":"source~bet-builder-rules-JA","22":"source~bet-builder-rules-KA","23":"source~bet-builder-rules-LT","24":"source~bet-builder-rules-LV","25":"source~bet-builder-rules-PL","26":"source~bet-builder-rules-PT-BR","27":"source~bet-builder-rules-RO","28":"source~bet-builder-rules-RU","29":"source~bet-builder-rules-SQ","30":"source~bet-builder-rules-TR","31":"source~bet-details-page","32":"source~betting-history-container","33":"source~betting-history-page","34":"source~betting-rules-DA","35":"source~betting-rules-DE","36":"source~betting-rules-EN","37":"source~betting-rules-ES","38":"source~betting-rules-ES-MX","39":"source~betting-rules-FR","40":"source~betting-rules-IT","41":"source~betting-rules-JA","42":"source~betting-rules-PL","43":"source~betting-rules-PT","44":"source~betting-rules-PT-BR","45":"source~betting-rules-RO","46":"source~betting-rules-RU","47":"source~betting-rules-SQ","48":"source~betting-rules-TR","49":"source~bonus-info","50":"source~cashout-terms-AR","51":"source~cashout-terms-DA","52":"source~cashout-terms-DE","53":"source~cashout-terms-EN","54":"source~cashout-terms-ES","55":"source~cashout-terms-ES-MX","56":"source~cashout-terms-ET","57":"source~cashout-terms-FI","58":"source~cashout-terms-FR","59":"source~cashout-terms-IT","60":"source~cashout-terms-JA","61":"source~cashout-terms-KA","62":"source~cashout-terms-KU","63":"source~cashout-terms-LT","64":"source~cashout-terms-LV","65":"source~cashout-terms-PL","66":"source~cashout-terms-PT","67":"source~cashout-terms-PT-BR","68":"source~cashout-terms-RO","69":"source~cashout-terms-RU","70":"source~cashout-terms-SQ","71":"source~cashout-terms-SR","72":"source~cashout-terms-TR","73":"source~esports-betting-rules-DA","74":"source~esports-betting-rules-DE","75":"source~esports-betting-rules-EN","76":"source~esports-betting-rules-ES","77":"source~esports-betting-rules-ES-MX","78":"source~esports-betting-rules-ET","79":"source~esports-betting-rules-FI","80":"source~esports-betting-rules-FR","81":"source~esports-betting-rules-IT","82":"source~esports-betting-rules-JA","83":"source~esports-betting-rules-KA","84":"source~esports-betting-rules-LT","85":"source~esports-betting-rules-LV","86":"source~esports-betting-rules-PL","87":"source~esports-betting-rules-PT","88":"source~esports-betting-rules-PT-BR","89":"source~esports-betting-rules-RO","90":"source~esports-betting-rules-RU","91":"source~esports-betting-rules-SQ","92":"source~esports-betting-rules-SR","94":"source~generated-mappings","95":"source~i18n-en-json","96":"source~i18n-fr-json","98":"source~settings-page","99":"source~streaming-carousel","100":"source~virtual-esports-betting-rules-EN","101":"source~virtual-esports-betting-rules-IT","102":"source~virtual-esports-betting-rules-JA","103":"source~virtual-esports-betting-rules-PL","105":"vendors~rc-slider","106":"vendors~react-google-recaptcha","107":"vendors~streaming-carousel"}[chunkId]||chunkId) + "." + {"0":"ef9bacdf8e6d3f1ed3e1","1":"437cbce4675815d533a7","2":"50579edf500a7476d65c","3":"f4e32a95f85ada1e1ec2","4":"b4d0da96f2f9b90418dc","5":"152c633ceb7958ea0edb","6":"bda3c2bfcedd8aed0c35","8":"747a270d4e2d08cce688","9":"f6cae92f81aee9506b7c","12":"edd74e9d7caab9b513cf","13":"435bec954667dd83a1a7","14":"c5d1f618770fb9a052c5","15":"2a567cfdd050dd87f998","16":"30f1a1fcd0c391709e54","17":"5b85a29e0bd25b9d465e","18":"84170822a3206eded6df","19":"5e50d0367ca47b9f31c5","20":"71d34f6815197316a68c","21":"8f1809fbb76f2e5e810f","22":"050268f3fe6c2c7aa1f2","23":"b2afda2d0adb9f78d620","24":"d2f3c79de4f8de2e0fb5","25":"3a8968a9c8a519b2e7ea","26":"9e50601a375895d44908","27":"a821a267340383aa50f9","28":"6c93f880deb0c1ba9823","29":"e7ade927eb84eee7aa59","30":"12f84820796f9b6546d6","31":"57ce141a5fe1c98f7b47","32":"61ef02a2e2441623761e","33":"97f78ea39dbed846d698","34":"56c2e88d723dd7cd696f","35":"bede19725a24e05884c7","36":"79a36c39a2b4f9935f06","37":"a19377db8465779564fe","38":"6f25624c6b563fd34ae5","39":"32835e4c90638dc04dc1","40":"9f81ce58e5c0d7793725","41":"4ba7327c7307a1b92cdc","42":"30e48b906e64c728d10f","43":"f2a42a50c55c696a7389","44":"fa94195c53a789af45d4","45":"c69c2183222c5b9b5815","46":"82a340e0df4d5c033131","47":"b8477f8885b78f3f62b2","48":"cc55fadcbf441a77477c","49":"b4e8ac72d522ad036cae","50":"5cd2f3263198eb15269d","51":"5fc3b2e2d2329036bdd5","52":"ef558e094c349954befd","53":"40e91df3d3eb252ca239","54":"3a2495cd8a392eac1ee2","55":"43506603bb2f4f430b74","56":"888849ab9ad8cf158e8d","57":"d3b3aab2831d53eaae82","58":"aacd200896e5942b4ef5","59":"0823aa4a3563a804587b","60":"132833a7e7db95c99041","61":"e4e7936bc6d0258775f9","62":"04d1a08dca86a51aea8b","63":"255974afb144435412ba","64":"ae71a79edec6388da06e","65":"a2e9d29edc0e822a0a63","66":"0da886a48fd3a3bdca27","67":"6ff9d1aa7cae892e3f33","68":"c024300c0df555adf95a","69":"0a8acea5c9c704869f11","70":"11b10f70c63c496ea511","71":"1d6899aa2fb8c118fef8","72":"65a828959eacbccbf2ff","73":"7f6ba10b73e2652999f7","74":"f7a7f116aeea8995a0f1","75":"11503637b3a11a475f54","76":"42adb96d30330ca72577","77":"8022b44811d408f564ee","78":"96107b697c063446351f","79":"679281491b172bcfb90e","80":"46bf1dfd697cdd767408","81":"cd45eb4a68d253209b80","82":"c93875e31414031c99b2","83":"1779f923fea0a3d0dbc6","84":"fa75b2a18a8ac151c2e1","85":"8186e98cc3c61196955b","86":"1c9c1d26bd47c003cd63","87":"5110b7ad2a000d7427aa","88":"bcaf5142c8da33527c54","89":"3f4ef9c4d9e4537f75d5","90":"bbf579b9981be0de430f","91":"178caac576cd4af9c900","92":"7ff3e32c6f79f785730c","94":"fc92fdf131f7a4259603","95":"d18c4f164ee306d7b066","96":"893301b6c46be0e16141","98":"f27f6711aa05196d4dc2","99":"965ff152839c233c3d3f","100":"69b8286382ef0c58b557","101":"fed7576a9703227808ef","102":"8e2f091d471b4dfd2507","103":"16453614428182041b53","105":"c45b6b2effef0bfb0f36","106":"c6e07e06230f907abe78","107":"3932bdc6ad8c676d45e9","108":"00977b736a36a1ecf646","109":"5269e577065d7f82a9b9","110":"d5212ba3c72cbf76460d","111":"d789f4c0b7abb803a545","112":"c51c3a0a3b9e815d2a0f","113":"78248693fe13430e8880","114":"a7e87969ef3984e1a9df","115":"bf8707278031e0ba0516","116":"dc7e47ba5fd120ef2596","117":"e8824bf47d42e4ab5ff9","118":"94504e9f4509f081fb0f","119":"ab1e27edca53dd3b2153","120":"888771fe29e1d2ad8d43","121":"ba23b199c65130ab3da6","122":"3fce90312e60ab2b579d","123":"127c07b0ecdbe55a800f","124":"07309be1b08d1d1ca12e","125":"89089d379018ddae063f","126":"08482f68a4c8afb57837","127":"8186fc1efc8b01cccf17","128":"b0b1458505a3d38560bb"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonpOMFE2_App"] = window["webpackJsonpOMFE2_App"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
